import React, { useState } from "react";
import PropTypes from 'prop-types';

const Search = ({ onSearch, className = "" }) => {
  const [query, setQuery] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (typeof onSearch === 'function') {
      onSearch(value);
    }
  };

  return (
    <div className={`${className}`}>
      <input
        type="text"
        value={query}
        onChange={handleSearch}
        placeholder="Search..."
        className="w-full px-4 py-2 border border-gray-300 rounded-md 
                 focus:outline-none focus:ring-2 focus:ring-blue-500 
                 text-gray-900 bg-white"
      />
    </div>
  );
};

Search.propTypes = {
  onSearch: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default Search;